import { lazy } from 'react';
import { Route, Routes } from 'react-router';
import { NotFound } from '../../app/routing/NotFound';

const Orders = lazy(() => import('./Orders'));

const OrderRoutes = () => (
  <Routes>
    <Route path="/" element={<Orders />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default OrderRoutes;
